import React from 'react';
import { Grid } from '@material-ui/core';
import {
  Title,
  Field,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { StyledData } from 'containers/CourtManagerLegalProceedings/Provision/styled-components';
import { get, isEmpty } from 'lodash';
import {
  extractVictims,
  isVictimMinor,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/utils';
import { numberWithCommas } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import {
  PARTIAL_JUGEMENT,
  RELIQUAT_APPEL,
  RELIQUAT_JUGEMENT,
  TOTAL_JUGEMENT,
  VICTIME_TYPES,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/constants';
import { COLORS } from 'constants/design';

const DataRecap: React.FC<any> = props => {
  const adults = get(props, 'encryptedDocumentsOfAdults', []);
  const minors = get(props, 'encryptedDocumentsOfMinors', []);
  const victimsCorporeal = get(props, 'rcCorpo.victimsCorpo', []);
  const victims = { adults, minors };

  const {
    blesseeMinorVictims,
    blesseeMajorVictims,
    deceaseVictims,
  } = extractVictims(victims, get(props, 'rcCorpo.victimsCorpo', []));

  const blesseeVictims = [...blesseeMinorVictims, ...blesseeMajorVictims];
  const blesseeTitle = !isEmpty(blesseeMinorVictims)
    ? VICTIME_TYPES.MINEURE_BLESSEE
    : !isEmpty(blesseeMajorVictims)
    ? VICTIME_TYPES.MAJEURE_BLESSEE
    : '';
  const decedeeTitle = !isEmpty(deceaseVictims)
    ? VICTIME_TYPES.DECEDEE_VICTIME
    : '';
  const showVictimIsMinor = (victim: any): boolean => {
    if (isEmpty(adults)) {
      return false;
    }

    return isVictimMinor(victimsCorporeal, victim.victimKey, props.rcCorpo);
  };
  const isAppeal = get(props, 'rcCorpo.regulationInfo.isAppeal', false);
  const natureCode = get(
    props,
    'rcCorpo.regulationInfo.natureCode',
    '',
  ).toString();
  const isRemainder =
    natureCode === RELIQUAT_APPEL || natureCode === RELIQUAT_JUGEMENT;
  const isPartialOrTotalJudgement =
    natureCode === PARTIAL_JUGEMENT || natureCode === TOTAL_JUGEMENT;

  const renderVictimDetails = (victim: any) => (
    <Grid container xs={12} direction="row" key={victim.victimKey}>
      <Grid item xs={2}>
        <Title style={{ color: COLORS.BLUE, marginLeft: '18px' }}>
          {victim.victimName}{' '}
          {showVictimIsMinor(victim) && `(${translate(messages.minor, props)})`}
        </Title>
      </Grid>
      <Grid item xs={10} container direction="row">
        <Grid item xs={10} direction="row" container>
          {isAppeal && !isEmpty(victim.arrestAmount?.toString()) && (
            <Grid item xs={3}>
              <Title>
                {translate(messages.appealCompensationAmount, props)}
              </Title>
              <Field>
                {numberWithCommas(victim.arrestAmount?.toString() || '0')}
              </Field>
            </Grid>
          )}
          <Grid item xs={3}>
            <Title>
              {translate(messages.judgementCompensationAmount, props)}
            </Title>
            <Field>{numberWithCommas(victim.judgementAmount.toString())}</Field>
          </Grid>
          {isVictimMinor(victimsCorporeal, victim.victimKey, props.rcCorpo) && (
            <Grid item xs={3}>
              <Title>{translate(messages.judgementCompanyAmount, props)}</Title>
              <Field>{numberWithCommas(victim.cnraAmount?.toString())}</Field>
            </Grid>
          )}
          {isPartialOrTotalJudgement && (
            <Grid item xs={3}>
              <Title>{translate(messages.rate, props)}</Title>
              <Field>{`${victim.executionRate}%`}</Field>
            </Grid>
          )}
          <Grid item xs={3}>
            <Title>
              {translate(messages.provisionalExecutionAmount, props)}
            </Title>
            <Field>
              {numberWithCommas(victim.executionProvAmount.toString())}
            </Field>
          </Grid>
        </Grid>
        <Grid item xs={9} direction="row" container>
          {isAppeal && !isEmpty(victim.appealReason) && (
            <Grid item xs={3}>
              <Title>{translate(messages.appealReason, props)}</Title>
              <Field>{victim.appealReason}</Field>
            </Grid>
          )}
          {!isEmpty(victim.judgementReason) && (
            <Grid item xs={3}>
              <Title>{translate(messages.judgementReason, props)}</Title>
              <Field>{victim.judgementReason || ''}</Field>
            </Grid>
          )}

          {isRemainder && (
            <Grid item xs={3}>
              <Title>{translate(messages.remainder, props)}</Title>
              <Field>
                {isRemainder
                  ? numberWithCommas(victim.remainderAmount.toString())
                  : ''}
              </Field>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );

  const renderDeceaseDetails = ([victimName, record]: [any, any]) => (
    <Grid container xs={12} direction="row" key={victimName}>
      <Grid item xs={2}>
        <Title style={{ color: COLORS.BLUE, marginLeft: '18px' }}>
          {victimName}
        </Title>
      </Grid>
      <Grid item xs={2}>
        <Title>{translate(messages.beneficiariesTitle, props)}</Title>
      </Grid>
      <Grid item xs={8} container>
        {record.map((info: any, index: number) => (
          <Grid container xs={12} direction="row" key={index}>
            <Grid item xs={3}>
              <Title>{info.nextOfKinName}</Title>
            </Grid>
            <Grid item xs={9} key={index} container direction="row">
              {isAppeal && !isEmpty(info.arrestAmount.toString()) && (
                <Grid item xs={3}>
                  <Title>
                    {translate(messages.beneficiaryAppealAmount, props)}
                  </Title>
                  <Field>
                    {numberWithCommas(info.arrestAmount.toString())}
                  </Field>
                </Grid>
              )}
              {!isEmpty(info.judgementAmount.toString()) &&
                parseInt(info.judgementAmount) !== 0 && (
                  <Grid item xs={3}>
                    <Title>
                      {translate(messages.beneficiaryJudgementAmount, props)}
                    </Title>
                    <Field>
                      {numberWithCommas(info.judgementAmount.toString())}
                    </Field>
                  </Grid>
                )}
              {!isRemainder && (
                <Grid item xs={3}>
                  <Title>{translate(messages.rate, props)}</Title>
                  <Field>{`${info.executionRate}%`}</Field>
                </Grid>
              )}
              {!isEmpty(info.executionProvAmount.toString()) &&
                parseInt(info.executionProvAmount) !== 0 && (
                  <Grid item xs={3}>
                    <Title>
                      {translate(messages.provisionalExecutionAmount, props)}
                    </Title>
                    <Field>
                      {numberWithCommas(info.executionProvAmount.toString())}
                    </Field>
                  </Grid>
                )}

              {isRemainder && (
                <Grid item xs={3}>
                  <Title>{translate(messages.remainderAmount, props)}</Title>
                  <Field>
                    {isRemainder
                      ? numberWithCommas(info.remainderAmount.toString())
                      : ''}
                  </Field>
                </Grid>
              )}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );

  return (
    <div>
      {blesseeTitle && <StyledData>{blesseeTitle}</StyledData>}
      {blesseeVictims.map(renderVictimDetails)}

      {decedeeTitle && <StyledData>{decedeeTitle}</StyledData>}
      {!isEmpty(deceaseVictims) && (
        <>{Object.entries(deceaseVictims).map(renderDeceaseDetails)}</>
      )}
    </div>
  );
};

export default DataRecap;
